<template>
  <div class="menu">
    <div class="menu-mobile">
      <div class="menu-mobile__close"></div>

      <div class="default-container">
        <ul class="menu-mobile__list">
          <li>
            <router-link
              :to="{ name: `${lang}-lavorazioni`, params: { lang } }"
              :class="{ 'isActive': ['processings', 'processings/list'].includes(fromRoute && fromRoute.meta.pageName) }">
                {{ $t('vociMenu.lavorazioni') }}
            </router-link>
          </li>
          <li>
            <router-link
              :to="{ name: `${lang}-settori`, params: { lang } }"
              :class="{ 'isActive': fromRoute && fromRoute.meta.pageName === 'sectors'}">
                {{ $t('vociMenu.settori') }}
            </router-link>
          </li>
          <li>
            <router-link
              :to="{ name: `${lang}-azienda`, params: { lang } }"
              :class="{ 'isActive': fromRoute && fromRoute.meta.pageName === 'company'}">
                {{ $t('vociMenu.azienda') }}
            </router-link>
          </li>
          <li>
            <router-link
              :to="{ name: `${lang}-contatti`, params: { lang } }"
              :class="{ 'isActive': fromRoute && fromRoute.meta.pageName === 'contacts'}">
                {{ $t('vociMenu.contatti') }}
            </router-link>
          </li>
        </ul>

        <ul class="menu-mobile__langs">
          <li>
            <a
            @click="handleLangClick"
            :href="translatedUrl"
            :class="{ 'isActive': lang === 'it'}">
              IT
            </a>
          </li>
          <li>
            <a
            @click="handleLangClick"
            :href="translatedUrl"
            :class="{ 'isActive': lang === 'en'}">
              EN
            </a>
          </li>
        </ul>

      </div>
    </div>

    <div class="menu-desktop"></div>
  </div>
</template>

<script>
import lang from '@/views/mixins/lang'
import _ from 'lodash'

export default {
  mixins: [ lang ],
  data: () => ({
    fromRoute: undefined
  }),
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.fromRoute = from
    })
  },
  computed: {
    translatedUrl: {
      get () {
        // Raccolgo i dati principali dei lang e della rotta corrente...
        const routeName = this.fromRoute && this.fromRoute.name
        const currentLang = this.lang
        const altLang = this.lang === 'en' ? 'it' : 'en'

        // ...poi controllo se la rotta corrente fa parte di una pagina figlia, che segue una logica diversa...
        const paramsType = this.fromRoute && this.fromRoute.params && this.fromRoute.params.type
        const mappedSubroutes = {
          en: {
            'raw-material-storage': 'stoccaggio-materie-prime',
            'mold-construction': 'costruzione-stampi',
            'cutting-with-plotter-and-manual': 'taglio-con-plotter-e-manuale',
            'lamination-in-clean-room': 'laminazione-in-clean-room',
            'curing': 'cottura',
            'finishing-and-assembly': 'finitura-e-assemblaggio',
            'painting': 'verniciatura',
            'quality-control': 'controllo-qualita'
          },
          it: {
            'stoccaggio-materie-prime': 'raw-material-storage',
            'costruzione-stampi': 'mold-construction',
            'taglio-con-plotter-e-manuale': 'cutting-with-plotter-and-manual',
            'laminazione-in-clean-room': 'lamination-in-clean-room',
            'cottura': 'curing',
            'finitura-e-assemblaggio': 'finishing-and-assembly',
            'verniciatura': 'painting',
            'controllo-qualita': 'quality-control'
          }
        }
        if (paramsType) {
          // Sono ricorso a delle rotte mappate perchè non sapevo più a che santo votarmi, sorry
          const mappedTranslatedSlug = mappedSubroutes[this.lang][paramsType]
          return this.$router.resolve({ name: _.replace(routeName, `${currentLang}-`, `${altLang}-`), params: { type: mappedTranslatedSlug } }).href
        }

        // ...altrimenti procedo con la conversione normale.
        return this.$router.resolve({ name: _.replace(routeName, `${currentLang}-`, `${altLang}-`) }).href
      }
    }
  },
  methods: {
    $_convertRoute (routeName, currentLang, lang) {
      // Metodo disattivato, la rotta alternativa è calcolata aggiornata da una computed con le casistiche
      return this.$router.resolve({ name: _.replace(routeName, `${currentLang}-`, `${lang}-`) }).href
    },
    handleLangClick () {
      const oppositeLang = this.lang === 'it' ? 'en' : 'it'
      localStorage.setItem('selectedLanguage', oppositeLang)
    }
  }
}
</script>

<style lang="scss">
@import "../assets/mixins/breakpoints";
.menu {
  position: fixed;
  top: 0;
  z-index: 75;
  height: 100vh;
  width: 100%;
}

.menu-mobile {
  background-color: #262624;
  padding-top: 10rem;
  height: 100vh;
  width: 100%;

  .default-container{
    height: 100%;

    .menu-mobile__list{
      top: calc(20% - 48px);
      transform: translate3d(0, -20%, 0);
    }
  }

  li{
    display: block;
    margin-top: 2rem;
    margin-bottom: 2rem;
  }

  li a{
    font-size: 1.8rem;
    line-height: 1.6;
    padding-top: 1rem;
    padding-bottom: 1rem;
    color: #9B9B9B;
    text-decoration: none;
    font-weight: 100;

    font-family: 'Sectra'; font-weight: 400;
    text-transform: uppercase; letter-spacing: .2rem;
  }
  li a.isActive{
    color: #EFEFF1;
  }

  li a::before{
    position: absolute;
    left: -1px;
    bottom: .5rem;
    width: 0;
    content: "";
    height: 2px;
    background-color: #679196;
    transition: width 600ms cubic-bezier(0.23, 1, 0.32, 1);
  }

  li a.isActive::before{
    width: calc(100% + 2px);
  }
}

.menu-transition-enter {
  opacity: 0;
}

.menu-transition-enter-to {
  opacity: 1;
}

.menu-transition-enter-active {
  transition: opacity 400ms cubic-bezier(0.23, 1, 0.32, 1);
  top: 0;
}

.menu-transition-leave {
  opacity: 1;
}

.menu-transition-leave-to {
  opacity: 0;
}

.menu-transition-leave-active {
  transition: opacity 400ms cubic-bezier(0.23, 1, 0.32, 1);
}

.menu-mobile__langs{
  position: fixed;
  bottom: 4rem;
  width: 100%;

  li{
    display: inline-block;
    margin-right: 3rem;
    a{
      font-size: 1.6rem;
      color: #9B9B9B;
      text-transform: uppercase;
      font-weight: 300;
    }
    a.router-link-active{
      color: #EFEFF1;
    }
    a::before{
      position: absolute;
      left: -1px;
      bottom: .2rem;
      width: 0;
      content: "";
      height: 2px;
      background-color: #679196;
      transition: width 600ms cubic-bezier(0.23, 1, 0.32, 1);
    }
    a.router-link-active::before{
      width: calc(100% + 2px);
    }
  }
}

</style>
